import { Box } from "@mui/material";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import { useTranslation } from "hhn-commons";

const DeleteBubble = () => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "message" });
  return (
    <Box
      sx={{
        padding: "15px",
        fontStyle: "italic",
        display: "flex",
      }}
    >
      <NotInterestedIcon color="error" /> {tNs("message.deletedMessage")}
    </Box>
  );
};
export default DeleteBubble;
